// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IqH6z","productName":"Table_productName__2xBU6"};